import { Box, Button, Text } from "../../../../../../mads";
import { Information } from "../../../../../../mads/icons";
import { useI18n } from "../../../../../../shared/I18n";
import { SlideIn } from "../../SlideIn";

import { colors } from "@indeed/ifl-tokens/react-native";
import React, { createContext, type ReactNode, useContext, useState } from "react";
import { StyleSheet } from "react-native";

type PopupContextType = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

const PopupContext = createContext<PopupContextType>({
  isOpen: false,
  setIsOpen: () => {},
});

const styles = StyleSheet.create({
  modalContent: {
    flexGrow: 0,
    paddingTop: 16,
    paddingBottom: 48,
    paddingLeft: 16,
    paddingRight: 16,
  },
});

function Popup() {
  const i18n = useI18n();
  const { isOpen, setIsOpen } = useContext(PopupContext);

  return (
    <SlideIn
      isOpen={isOpen}
      onDismiss={() => setIsOpen(false)}
      title={
        <Text level={3} sx={{ color: colors.foregroundStrong }}>
          {i18n.pgettext("More information about Employer insights", "Employer insights")}
        </Text>
      }
      sx={{ backgroundColor: colors.background }}
    >
      <Box sx={styles.modalContent}>
        <Text level={3}>
          {i18n.pgettext(
            "See how active this employer is and how likely they are to respond to candidates.",
            "See how active this employer is and how likely they are to respond to candidates.",
          )}
        </Text>
      </Box>
    </SlideIn>
  );
}

export function EmployerInsightsPopoverProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const context = { isOpen, setIsOpen };

  return (
    <PopupContext.Provider value={context}>
      {children}
      {isOpen && <Popup />}
    </PopupContext.Provider>
  );
}

export function EmployerInsightsPopover() {
  const i18n = useI18n();
  const { setIsOpen } = useContext(PopupContext);

  return (
    <Button
      variant="text"
      ariaLabel={i18n.gettext("More information about employer insights")}
      onPress={() => setIsOpen(true)}
      iconOnly={true}
      iconBefore={<Information size="xs" variant="stroke" fill={colors.neutral1000} aria-hidden />}
    />
  );
}
